import { ws } from "../../../utils/common";

export const getFutureProgramWS = async ({ id_association }) => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "calendar/future",
    { calendar: true, id_association },
    null,
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};
